<template>
  <div slot="header" class="clearfix" style="position: relative;">
    <ods-row :gutter="10">
      <tarjeta-cadena-comercios
        @loader="handlerloader"
        @mostrarTpv="mostrarTpvD"
        @mostrarListMov="mostrarListMove"
        @registrosTotales="registrosTot"
        @primeraPagina="primeraPag"
        @listadoPorDefecto="listadoPorDefect"
        v-for="cadenaComercios in this.lCommercialFijo"
        :data="cadenaComercios"
        :key="cadenaComercios.registro_Numero">
      </tarjeta-cadena-comercios>
  </ods-row>
  </div>
</template>

<script>
import TarjetaCadenaComercios from '@/components/cadena/TarjetaComercioSeleccionable'
import { mapGetters } from 'vuex'

export default {
  components: {
    TarjetaCadenaComercios
  },
  data () {
    return {
    }
  },
  methods: {
    ...mapGetters([
      'getlistCommercialFijoData'
    ]),
    handlerloader (params) {
      this.$emit('finalLoader', params)
    },
    mostrarTpvD (params) {
      this.$emit('finalTpv', params)
    },
    mostrarListMove (params) {
      this.$emit('finalListMov', params)
    },
    registrosTot (params) {
      this.$emit('finalregistrosTotales', params)
    },
    primeraPag (params) {
      this.$emit('finalPrimeraPag', params)
    },
    listadoPorDefect (params) {
      this.$emit('finalListadoPorDefect', params)
    }
  },
  computed: {
    lCommercialFijo () {
      let datosCommercial = []
      if (this.$store.getters.getlistCommercialFijoData !== undefined) {
        if (this.$store.getters.getlistCommercialFijoData !== '') {
          datosCommercial = this.$store.getters.getlistCommercialFijoData
        }
      }
      return datosCommercial
    }
  }
}
</script>
<style lang="scss" scoped>
.direction {
    color: $--color-neutral-1;
}

.info-comercio {
    font-weight: $font-weight-regular;
    margin-top: 11px;
}

.icon-button {
      color: $--color-neutral-2;
}

/deep/ .ods-module__header {
    padding-bottom: 13px;
    padding-top: 20px;
    font-size: 14px;
    font-weight: $font-weight-medium;
}

</style>
